/**
 * Dovie Home — Complete the set
 * Checkbox add-ons with live total + multi-add on ATC (matching Size/Color best-effort).
 */
(function () {
  const MONEY_FORMAT_FALLBACK = '${{amount}}';

  function formatMoney(cents, format) {
    const value = (Number(cents) / 100).toFixed(2);
    const fmt = format || window.theme?.settings?.moneyFormat || MONEY_FORMAT_FALLBACK;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, fmt);
      } catch (e) {
        /* fall through */
      }
    }
    const withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function parseVariants(el) {
    try {
      return JSON.parse(el.getAttribute('data-variants') || '[]');
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(root) {
    const sizeInput =
      root.querySelector('select[name="options[Size]"]') ||
      root.querySelector('[name="options[Size]"]:checked') ||
      document.querySelector('select[name="options[Size]"]') ||
      document.querySelector('[name="options[Size]"]:checked');
    const colorInput =
      root.querySelector('fieldset input[name="options[Color]"]:checked') ||
      root.querySelector('select[name="options[Color]"]') ||
      document.querySelector('fieldset input[name="options[Color]"]:checked') ||
      document.querySelector('select[name="options[Color]"]');

    return {
      size: sizeInput ? sizeInput.value : null,
      color: colorInput ? colorInput.value : null,
    };
  }

  function matchVariant(variants, size, color) {
    if (!variants.length) return null;
    const available = variants.filter((v) => v.available !== false);

    const exact = available.find((v) => v.size === size && v.color === color);
    if (exact) return exact;

    const sizeOnly = available.find((v) => v.size === size);
    if (sizeOnly) return sizeOnly;

    const colorOnly = available.find((v) => v.color === color);
    if (colorOnly) return colorOnly;

    return available[0] || variants[0] || null;
  }

  function getMainVariantPriceCents(form, fallback) {
    const idInput = form?.querySelector('input[name="id"]');
    const variantId = idInput ? idInput.value : null;
    const productJson = document.querySelector('[data-product-json], script[type="application/json"][data-product]');
    /* Prefer published Shopify product JSON from Dawn variant select */
    const variantSelects = document.querySelectorAll('variant-selects[data-section], variant-radios[data-section]');
    for (const el of variantSelects) {
      const script = el.querySelector('script[type="application/json"]');
      if (!script) continue;
      try {
        const variants = JSON.parse(script.textContent);
        const match = variants.find((v) => String(v.id) === String(variantId));
        if (match && typeof match.price === 'number') return match.price;
      } catch (e) {
        /* continue */
      }
    }
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        const variants = data.variants || data;
        if (Array.isArray(variants)) {
          const match = variants.find((v) => String(v.id) === String(variantId));
          if (match && typeof match.price === 'number') return match.price;
        }
      } catch (e) {
        /* ignore */
      }
    }
    return fallback;
  }

  function selectedAddonItems(cts, size, color) {
    const items = [];
    cts.querySelectorAll('[data-addon-checkbox]:checked').forEach((cb) => {
      const variant = matchVariant(parseVariants(cb), size, color);
      if (variant && variant.id) {
        items.push({
          id: variant.id,
          quantity: 1,
          price: variant.price,
          checkbox: cb,
        });
      }
    });
    return items;
  }

  function updateTotal(cts) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const basePrice = getMainVariantPriceCents(cts, Number(cts.dataset.mainPrice || 0));
    const { size, color } = getSelectedOptions(document);
    const addons = selectedAddonItems(cts, size, color);
    let total = Number(basePrice) || 0;
    addons.forEach((a) => {
      total += Number(a.price) || 0;
    });
    const totalEl = cts.querySelector('[data-cts-total]');
    if (totalEl) {
      totalEl.textContent = formatMoney(total, cts.dataset.moneyFormat);
    }
  }

  function bindCts(cts) {
    if (cts.dataset.bound === 'true') return;
    cts.dataset.bound = 'true';

    cts.addEventListener('change', (e) => {
      if (e.target.matches('[data-addon-checkbox]')) updateTotal(cts);
    });

    document.addEventListener('change', (e) => {
      if (
        e.target.matches('[name="options[Size]"], [name="options[Color]"], [name="id"]') ||
        e.target.closest('variant-selects, variant-radios')
      ) {
        updateTotal(cts);
      }
    });

    /* Dawn publishes variant change via pub/sub in newer themes; also listen input */
    document.addEventListener('variant:change', () => updateTotal(cts));
    updateTotal(cts);
  }

  function findCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function multiAdd(items, form) {
    const cart = findCart();
    const payload = {
      items: items.map((i) => ({ id: Number(i.id), quantity: Number(i.quantity) || 1 })),
    };

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      cart.setActiveElement?.(document.activeElement);
    }

    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    }).then((r) => r.json());
  }

  function interceptSubmit(cts) {
    const form =
      document.querySelector(`#product-form-${cts.id.replace('DovieCompleteTheSet-', '')}`) ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || form.dataset.ctsIntercept === 'true') return;
    form.dataset.ctsIntercept = 'true';

    form.addEventListener(
      'submit',
      function (evt) {
        const { size, color } = getSelectedOptions(document);
        const addons = selectedAddonItems(cts, size, color);
        if (!addons.length) return; /* default Dawn product-form handler */

        evt.preventDefault();
        evt.stopImmediatePropagation();

        const productForm = form.closest('product-form');
        const submitButton = form.querySelector('[type="submit"]');
        const spinner = productForm?.querySelector('.loading__spinner');

        if (submitButton?.getAttribute('aria-disabled') === 'true') return;

        submitButton?.setAttribute('aria-disabled', 'true');
        submitButton?.classList.add('loading');
        spinner?.classList.remove('hidden');

        const mainId = form.querySelector('input[name="id"]')?.value;
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
        const items = [{ id: mainId, quantity: qty }, ...addons.map((a) => ({ id: a.id, quantity: 1 }))];

        multiAdd(items, form)
          .then((response) => {
            if (response.status) {
              const msg = response.description || response.message || 'Could not add items';
              const errWrap = productForm?.querySelector('.product-form__error-message-wrapper');
              const errMsg = productForm?.querySelector('.product-form__error-message');
              if (errWrap && errMsg) {
                errWrap.hidden = false;
                errMsg.textContent = msg;
              }
              return;
            }

            const cart = findCart();
            if (!cart) {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }

            if (typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'dovie-complete-the-set',
                cartData: response,
              });
            }
          })
          .catch((err) => {
            console.error('[dovie-complete-the-set]', err);
          })
          .finally(() => {
            submitButton?.classList.remove('loading');
            submitButton?.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          });
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-dovie-complete-the-set]').forEach((cts) => {
      bindCts(cts);
      interceptSubmit(cts);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
